module.exports = __webpack_public_path__ + "static/media/loading.8523e814.gif";


//////////////////
// WEBPACK FOOTER
// ./src/loading.gif
// module id = 146
// module chunks = 0